import { API_MAP } from '@common/api/api-map';
export const reportApiMap = new Map([
    [API_MAP.CAN_USE_COUPONS, 'checkout'],
    [API_MAP.CAN_USE_COUPONS, 'checkout'],
    [API_MAP.COUPON_LIST, 'checkout'],
    [API_MAP.COUPON_CODE_CAN_USE, 'checkout'],
    [API_MAP.CREATE_ORDER, 'checkout'],
    [API_MAP.CHECKOUT_INFO, 'checkout'],
    [API_MAP.CHECKOUT_POINT_DETAIL, 'checkout'],
    [API_MAP.ASIA_PAY, 'checkout'],
    [API_MAP.CART_COUNT, 'cart'],
    [API_MAP.CART_DETAIL, 'cart'],
    [API_MAP.CART_MULTI_ADD, 'cart'],
    [API_MAP.CART_SELECTED_ALL, 'cart'],
    [API_MAP.CART_DELETE_SELECTED_ALL, 'cart'],
    [API_MAP.CART_SELECT_PROMOTION, 'cart'],
    [API_MAP.CART_SELECT_GOODS, 'cart'],
    [API_MAP.CART_CHANGE_GOODS_COUNT, 'cart'],
    [API_MAP.CART_DELETE_GOODS, 'cart'],
    [API_MAP.CART_ADD, 'cart']
]);
